import AboutSection from './AboutSection';

export default AboutSection;
